/*
 * Copyright (c) 2015 - 2023 by KAA Soft. All rights reserved.
 */

export var loadingInput = {
  start: function start(element) {
    var input;
    if (element instanceof HTMLElement && element) {
      input = element;
    }
    if (typeof element === "string" && graviton_app.isSelectorValid(element)) {
      input = document.querySelector(element);
    }
    if (!input) return;
    var container = input.closest('.input-container');
    if (container) {
      container.classList.add('input-loading');
      return;
    }
    // create loading element
    var loadingEL = document.createElement('div');
    loadingEL.classList.add('loading');
    // create wrapper container
    var wrapper = document.createElement('div');
    wrapper.classList.add('input-container', 'input-loading');
    // insert wrapper before el in the DOM tree
    input.parentNode.insertBefore(wrapper, input);
    // move el into wrapper
    wrapper.appendChild(input);
    wrapper.appendChild(loadingEL);
  },
  finish: function finish(element) {
    var input;
    if (element instanceof HTMLElement && element) {
      input = element;
    }
    if (typeof element === "string" && graviton_app.isSelectorValid(element)) {
      input = document.querySelector(element);
    }
    if (!input) return;
    var container = input.closest('.input-container');
    // console.log(container);
    container.classList.remove('input-loading');
  }
};